import(/* webpackMode: "eager" */ "/home/runner/work/tud-website/tud-website/node_modules/.pnpm/next@14.2.35_@babel+core@7.28.0_@opentelemetry+api@1.9.0_@playwright+test@1.54.2_babel-_5bff9c3197e981f02092deb89f915fe1/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager", webpackExports: ["AdSlot"] */ "/home/runner/work/tud-website/tud-website/src/components/Ads/GPT.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/tud-website/tud-website/src/components/Header/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/tud-website/tud-website/src/components/NavBar/NavBarCategories.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/tud-website/tud-website/src/components/Newsletters/SubscribeDrawerButton.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/tud-website/tud-website/src/components/PreviewAlert/index.tsx");
